import { component } from "picoapp";
import getProductJson from "../lib/getProductJson.js";
import { formatMoney } from "../lib/currency.js";
import $ from "jquery";
import { getQueryStringParameter, setQueryStringParameter } from "../lib/utils";
import { isUK, isUSA } from "../lib/customerLocation";

export default component((node, context) => {
  const initialVariantId = node.dataset.initialVariantId;
  const $optionTitle = node.querySelector(".js-option");
  const $variantPrice = node.querySelector(".js-price");

  // cache
  getProductJson();

  if (!getQueryStringParameter("variant")) {
    setQueryStringParameter("variant", initialVariantId);
  }

  window.addEventListener("variant-selected:id", async (event) => {
    const product = await getProductJson();
    const { variant: variantId } = event.detail;
    const variant = product.variants.find(
      (v) => parseInt(v.id) === parseInt(variantId)
    );
    if (!variant) return;

    const { currentVariant } = context.getState();
    if (currentVariant.id === parseInt(variantId)) {
      return false;
    }
    context.hydrate({ currentVariant: variant });
    setQueryStringParameter("variant", variant.id);
    if (variant.available) {
      $(".js-add-to-cart").show();
    } else {
      $(".js-add-to-cart").hide();
    }

    $optionTitle.innerHTML = variant.title;
    $variantPrice.innerHTML = formatMoney(
      variant.price,
      // eslint-disable-next-line no-template-curly-in-string
      "${{amount_no_decimals}}"
    );

    if (isUK() || isUSA()) {
      window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
      window.KlarnaOnsiteService.push({ eventName: "refresh-placements" });
    }
  });
});
